import React, { useState, useEffect } from 'react';
// import { useNotification } from '../../hooks/useNotification';
import { useTheme } from '../../context/shared/ThemeContext'
import { ChartBarIcon } from '@heroicons/react/24/outline';
import apiService from '../../services/shared/apiService';

interface SymbolicTrendsPanelProps {
  patientId: string;
}

interface Trend {
  theme: string;
  count: number;
  is_escalating: boolean;
}

const SymbolicTrendsPanel: React.FC<SymbolicTrendsPanelProps> = ({ patientId }) => {
  const { themeClasses } = useTheme();
  // const { addToast } = useNotification();
  const [trends, setTrends] = useState<Trend[]>([]);
  const [driftDetected, setDriftDetected] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTrends = async () => {
      if (!patientId) return;
      setIsLoading(true);
      try {
        const response = await apiService.getSymbolicTrends(patientId);
        setTrends(response.trends);
        setDriftDetected(response.symbolic_drift_detected);
      } catch (error) {
        console.error('Failed to fetch symbolic trends:', error);
        // addToast('Failed to fetch symbolic trends.', 'error');
      } finally {
        setIsLoading(false);
      }
    };

    fetchTrends();
  }, [patientId]);

  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Symbolic Trends (Last 30 Days)</h3>
      {isLoading ? (
        <p>Loading symbolic trends...</p>
      ) : (
        <div>
          {driftDetected && (
            <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 rounded-md">
              <p className="font-bold text-yellow-800">
                ⚠️ Symbolic Drift or Looped Language Detected
              </p>
              <p className="text-sm text-yellow-700">
                Patient may be exhibiting recursive thought patterns.
              </p>
            </div>
          )}
          {trends.length > 0 ? (
            <ul className="space-y-2">
              {trends.map(trend => (
                <li key={trend.theme} className="flex justify-between items-center p-2 bg-gray-100 rounded">
                  <span className="font-medium">{trend.theme}</span>
                  <span className="text-sm text-gray-600">Count: {trend.count}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No significant symbolic trends detected in the last 30 days.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SymbolicTrendsPanel; 